import {
  ExamLocationRequestRoomComputerInfoForm,
  mapComputerInfoToDefaultValues,
  useExamRoomRequestInfo,
} from '@exam-center/exam-location-management';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { PaperSection } from '@shared/components';
import { usePermission, validatePermissions } from '@shared/permissions';

export default function ExamLocationRequestRoomComputerInfoEditPage() {
  const { examRoomRequestInfo, isReadonly } = useExamRoomRequestInfo();
  const { permissions } = usePermission();

  const hasUpdatePermission = validatePermissions(
    APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST.UPDATE,
    permissions,
  );

  const defaultValues = mapComputerInfoToDefaultValues(
    examRoomRequestInfo.examRoomRequestComputerInfo?.info,
  );

  return (
    <PaperSection title='ข้อมูลเกี่ยวกับอุปกรณ์คอมพิวเตอร์'>
      <ExamLocationRequestRoomComputerInfoForm
        isReadonly={isReadonly || !hasUpdatePermission}
        defaultValues={defaultValues}
      />
    </PaperSection>
  );
}
